import { render, staticRenderFns } from "./FindSupplier.vue?vue&type=template&id=18024f80"
import script from "./FindSupplier.vue?vue&type=script&lang=ts"
export * from "./FindSupplier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports